var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lsa-account-alerts',{attrs:{"alerts":_vm.snapshot.alerts,"checked-at":_vm.snapshot.checked_at,"stale":_vm.snapshot.stale}})
}
var staticRenderFns = []

export { render, staticRenderFns }